import { Helmet } from 'react-helmet-async';
import MainLayout from '../../layouts/MainLayout';

const Career = () => {
  return (
    <MainLayout>
      {/* Set SEO Metadata and Canonical Tag */}
        <Helmet>
          <title>Careers | paralegal.lk</title>
          <meta
            name="description"
            content="Learn about paralegal.lk, a platform providing access to Sri Lankan legal resources, including over 20,000 appellate court decisions since 1880."
          />
          <link rel="canonical" href="https://www.paralegal.lk/careers" />
        </Helmet>

      <div className="flex flex-col justify-center mx-auto w-full max-w-6xl mt-50 p-20 text-pl-text-primary">
        <h1 className="mb-4 font-display font-bold text-22 text-center">
          Call for Internships in Software Engineering and Machine Learning at
          paralegal.lk
        </h1>
        <section className="mb-6">
          <h2 className="font-semibold text-18 mb-2">Who are we?</h2>
          <p className="leading-relaxed mb-4">
            We are a legal information technology company transforming how
            lawyers and lay people access legal information in Sri Lanka. Our
            first product{' '}
            <a
              href="https://paralegal.lk"
              className="font-bold text-pl-accent"
            >
              paralegal.lk
            </a>
            , a fast and powerful legal search engine, is loved by more than
            150+ lawyers and has supported thousands of legal searches over the
            past six months.
          </p>
        </section>
        <section className="mb-6">
          <h2 className="font-semibold text-18 mb-2">Why intern with us?</h2>
          <p className="leading-relaxed mb-4">
            We make sure that all our interns work across our technology stack
            which includes:
          </p>
          <ul className="list-disc list-inside leading-relaxed mb-4 [text-indent:-1.5rem] [padding-left:3.5rem]">
            <li>
              <strong>Python and friends:</strong> PyTorch, Pandas, NumPy, etc.
              for machine learning, natural language processing, and data
              science.
            </li>
            <li>
              <strong>JavaScript and friends:</strong> Node.js, React.js, etc.
              for web application development.
            </li>
            <li>
              <strong>Databases:</strong> MongoDB and DynamoDB for database
              requirements.
            </li>
            <li>
              <strong>Cloud services:</strong> AWS and GCP for cloud services.
            </li>
            <li>
              <strong>Web serving:</strong> Nginx for web serving.
            </li>
            <li>
              <strong>Payment integration:</strong> International payment
              gateways for transaction processing.
            </li>
          </ul>
          <p className="leading-relaxed mb-4">
            Our interns do not work on toy problems. Within a few weeks, we get
            them contributing production code.
          </p>
        </section>
        <section className="mb-6">
          <h2 className="font-semibold text-18 mb-2">Internship Assignment</h2>
          <p className="leading-relaxed mb-4">
            As part of our internship selection process, candidates are required to complete a technical assignment. 
            The full assignment details and submission requirements are available in the GitHub repository below.
          </p>
          <a
            href="https://github.com/ParalegalLK/internship-assignment"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-pl-accent hover:underline"
          >
            View Internship Assignment on GitHub
          </a>
        </section>
        <section className="mb-6">
          <h2 className="font-semibold text-18 mb-2">How to Apply</h2>
          <p className="leading-relaxed mb-4">
            If you are interested in joining paralegal.lk, please complete the internship assignment and submit your solution as a public GitHub repository. 
            Once completed, email the GitHub link along with your CV and a brief cover letter to{' '}
            <a
              href="mailto:admin@paralegal.lk"
              className="hover:underline text-pl-accent"
            >
              admin@paralegal.lk
            </a>.
          </p>
          <p className="leading-relaxed">
            Applications without a completed assignment submission will not be considered.
          </p>
        </section>
      </div>
    </MainLayout>
  );
};

export default Career;
